import { ObjectValues } from '../../app/types/utilityTypes';

export const LID_EXPORT_FORMATS = {
  ACMD: 0,
  EXCEL: 1,
  CSV: 2,
} as const;

export type LidExportFormat = ObjectValues<typeof LID_EXPORT_FORMATS>;
